import React from 'react';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { CopyChunky } from '@eventbrite/legacy-eds.iconography';

import { useIntl } from 'react-intl';

const DefaultCopyIconButtonComponent = () => {
    const intl = useIntl();
    return (
        <IconButton
            iconType={<CopyChunky />}
            title={intl.formatMessage({ id: 'Copy', defaultMessage: 'Copy' })}
        />
    );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const DefaultCopyIconButton = (_hasCopied: boolean) => {
    return <DefaultCopyIconButtonComponent />;
};
